import { Menu } from 'antd'
import React, { FunctionComponent, useContext } from 'react'
import { generatePath, Link } from 'react-router-dom'

import { groupShowRoutes } from '../../containers/Router/routes'
import ContentLoader from '../../components/ContentLoader'
import SubpageLayout from '../SubpageLayout'

import './groupShowLayout.less'
import { LocalizationContext } from '../../providers/LocalizationProvider'
import { Group } from '../../providers/ClientProvider/client/services/groups/types'

interface GroupShowLayoutViewProps {
  children?: React.ReactNode
  group?: Group
  menuSelectedKey?: string
  id: string
}

const GroupShowLayoutView: FunctionComponent<GroupShowLayoutViewProps> = (props) => {
  const { t, dictionary } = useContext(LocalizationContext)
  const layouts = dictionary.layouts

  return (
    <ContentLoader loading={!props.group}>
      <SubpageLayout title={props.group ? `${props.group?.name}` : ''} page={t(layouts.groups)}>
        <Menu
          mode='horizontal'
          selectedKeys={props.menuSelectedKey ? [props.menuSelectedKey] : undefined}
        >
          <Menu.Item key={groupShowRoutes.details.path}>
            <Link to={generatePath(groupShowRoutes.details.path, { id: props.id })} replace>
              {t(layouts.details)}
            </Link>
          </Menu.Item>
          <Menu.Item key={groupShowRoutes.workers.path}>
            <Link to={generatePath(groupShowRoutes.workers.path, { id: props.id })} replace>
              {t(layouts.workers)}
            </Link>
          </Menu.Item>
        </Menu>
        <div className='group-show-layout'>{props.children}</div>
      </SubpageLayout>
    </ContentLoader>
  )
}

export default GroupShowLayoutView
